import { Package } from '../../../store/package/reducer'

/*
 * The PayPro checkout a "buy a package" campaign button opens, for the
 * campaign dialog's Test — built as espy-dashboard builds it
 * (function/payment.ts packageCheckoutUrl). Two things only the dashboard
 * knows are filled in here: the user's uid (a placeholder) and the currency,
 * which there comes from the app (IRBIS → EUR, ClearCheck → USD, Kabat → NIS)
 * and here from the package's domain.
 */

export const currencyOf = (domain?: string | null) =>
  domain === 'tools.clearcheck.io' ? 'USD' : domain === 'bgc.kabat.ai' ? 'NIS' : 'EUR'

const WEBINT_TYPES = ['webinthub', 'webinthub_subpackage', 'webinthub_upgrade']

/** `uid: null` leaves out the account fields — a checkout to look at, not to pay */
export function checkoutUrl(p: Package, annual: boolean, uid: string | null): string {
  const useAnnual = annual && !!p.annualProductId && !!p.annualPrice
  const currency = currencyOf(p.packageDomain)
  const url = new URL('https://store.payproglobal.com/checkout')
  url.searchParams.set('exfo', '742')
  url.searchParams.set('products[1][id]', String(useAnnual ? p.annualProductId : p.productId))
  url.searchParams.set('products[1][Name]', String(p.title))
  url.searchParams.set(`products[1][Price][${currency}][amount]`, String(useAnnual ? p.annualPrice : p.price))
  url.searchParams.set('currency', currency)
  if (uid !== null) {
    url.searchParams.set('x-uid', uid)
    url.searchParams.set('x-packageId', String(p.id))
    if (WEBINT_TYPES.includes(p.type)) url.searchParams.set('x-packageType', p.type)
  }
  return url.href
}

/** the same, one parameter a line and not encoded — to read */
export function readableUrl(href: string): string {
  const url = new URL(href)
  const params = Array.from(url.searchParams.entries()).map(([k, v], i) => `${i ? '&' : '?'}${k}=${v}`)
  return [`${url.origin}${url.pathname}`, ...params.map((p) => `  ${p}`)].join('\n')
}
